import React, { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-input-2';
import { useTranslate } from '../TranslationText';
import { arabicLocalization } from '../phoneNumberArabicLocaliztion/phoneListArabicLocalization';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default function PhoneDropDownInput({
    value,
    hideLable = false,
    label,
    htmlTags = "",
    required = false,
    disabled = false,
    onChange = () => { },
}) {

    const { translate } = useTranslate();
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';

    const [isValidNumber, setIsValidNumber] = useState(true);
    const [enteredPhoneNumber, setEnteredPhoneNumber] = useState(value);

    const validatePhoneNumber = (phoneNumber = "", country) => {

        if (!phoneNumber || phoneNumber === country?.dialCode) return true;

        try {
            const phone = parsePhoneNumberFromString("+" + phoneNumber);

            if (!phone) return false;

            return phone.isValid();
        } catch (error) {
            console.error("Invalid phone number:", error);
            return false;
        }
    };

    useEffect(() => {
        setEnteredPhoneNumber(value)
    }, [value])

    return (
        <>
            {!hideLable && (
                <label htmlFor={label} className="capatalize_text">
                    {label}
                    {required && <i style={{ color: "red", margin: "auto 2px" }}>*</i>}
                </label>
            )}

            {htmlTags}

            <PhoneInput
                disabled={disabled}
                country={'ae'}
                countryCodeEditable={true}
                inputStyle={{ direction: 'ltr' }}
                buttonStyle={{ direction: 'ltr' }}
                localization={currentLanguage === 'ar' ? arabicLocalization : {}}
                dropdownClass="PhoneDropDown"
                searchPlaceholder={translate('web.search', 'Search')}
                onChange={(value, country) => {
                    setEnteredPhoneNumber(value);
                    setIsValidNumber(validatePhoneNumber(value, country));
                    onChange(value,validatePhoneNumber(value, country));
                }}
                value={enteredPhoneNumber}
                autoFormat
                containerClass="w-100"
                inputClass="w-100"
                isValid={(inputNumber, country) => validatePhoneNumber(inputNumber, country)}
                enableSearch
                copyNumbersOnly
                inputProps={{ required }}
            />

            {!isValidNumber &&
                <div className='text-danger'>
                    {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                </div>
            }
        </>
    );
}
